// extracted by mini-css-extract-plugin
module.exports = {"main-black":"#222","range":"ScoreRange-module__range___3Y7Hl","ticks":"ScoreRange-module__ticks___2mTbh","rangeLabels":"ScoreRange-module__rangeLabels___1Xph0"};